import Costs from "./Costs";
import Interval from "./Interval";
import Confirm from "./Confirm";

export default {
  COSTS: Costs,
  INTERVAL: Interval,
  CONFIRM: Confirm,
};
